<template>
  <div>
    <div class="title">
      推广人数 <span>{{ first + second + third + forth + fifth }}</span> 人
    </div>
    <div class="tab-list">
      <div class="item" :class="index === 0 ? 'on' : ''" @click="changIndex(0)">
        一级({{ first }})
      </div>
      <div
        class="item"
        :class="index === 1 ? 'on' : ''"
        @click="changIndex(1)"
        v-if="userInfo.certification_type > 2"
      >
        二级({{ second }})
      </div>
      <div
        class="item"
        :class="index === 2 ? 'on' : ''"
        @click="changIndex(2)"
        v-if="userInfo.certification_type > 3"
      >
        三级({{ third }})
      </div>
      <div
        class="item"
        :class="index === 3 ? 'on' : ''"
        @click="changIndex(3)"
        v-if="userInfo.certification_type > 4"
      >
        四级({{ forth }})
      </div>
      <div
        class="item"
        :class="index === 4 ? 'on' : ''"
        @click="changIndex(4)"
        v-if="userInfo.certification_type > 5"
      >
        五级({{ fifth }})
      </div>
    </div>
    <div class="people-box">
      <div
        class="people"
        v-for="(item, index) of UserList"
        :key="item.uid"
        @click="changeUrl(item)"
      >
        <div class="img">
          <img :src="item.avatar" alt="" />
        </div>
        <div class="name">
          <div class="tip">
            {{ item.nickname }}--{{ typeNames[index]
            }}<span class="brokerage"
              >({{ item.brokerage !== 0 ? item.brokerage : "" }})</span
            >
          </div>
          <div class="time">加入时间: {{ item.time }}</div>
        </div>
        <div
          class="user-poster"
          @click.stop="showUserPoster(item.uid)"
          v-if="item.certification_type == '醫生'"
        >
          推广码
        </div>
        <div class="sale">
          <div @click.stop="toMemberList(item.uid)">
            <span>{{ item.childCount }}</span
            >人
          </div>
          <div>{{ item.orderCount }}单</div>
          <div>{{ item.numberCount ? item.numberCount : 0 }}盒</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUser, getGroupCount } from "@api/user";
export default {
  name: "BusinessTotal",
  data() {
    return {
      param: {
        grade: 0,
        keyword: "",
        limit: 15,
        page: 1,
        sort: ""
      },
      index: 0,
      UserList: [],
      first: "",
      second: "",
      third: "",
      forth: "",
      fifth: "",
      userInfo: {}
    };
  },
  watch: {
    $route(n) {
      console.log("n");
      console.log(n);
      if (n.name == "GroupMemberList") {
        this.spreadUserList();
      }
    }
  },
  created() {
    getUser()
      .then(res => {
        this.userInfo = res.data;
      })
      .catch(err => {
        console.log(err.msg);
      });
    this.spreadUserList();
  },
  computed: {
    typeNames() {
      return this.UserList.map(item => {
        switch (item.certification_type) {
          case 0:
            return (item.certification_type = "");
          case 1:
            return (item.certification_type = "患者");
          case 2:
            return (item.certification_type = "醫生");
          case 3:
            return (item.certification_type = "代表");
          case 4:
            return (item.certification_type = "代理");
          case 5:
            return (item.certification_type = "省代");
          case 6:
            return (item.certification_type = "总代");
        }
      });
    }
  },
  methods: {
    spreadUserList() {
      let { uid } = this.$route.query;
      let screen = Object.assign({}, this.param, { uid });
      getGroupCount(screen).then(res => {
        console.log("?");
        console.log(res);
        this.UserList = res.data.list;
        this.first = res.data.total;
        this.second = res.data.totalLevel;
        this.third = res.data.totalLevel2;
        this.forth = res.data.totalLevel3;
        this.fifth = res.data.totalLevel4;
      });
    },
    changIndex(index) {
      if (this.index === index) return;
      this.index = index;
      this.param.grade = index;
      this.spreadUserList();
    },
    changeUrl: function(val) {
      // 需过滤医生角色
      if (val.certification_type !== "患者" && this.index == 0) {
        var uid = val.uid;
        var certification_type = this.userInfo.certification_type;
        //console.log(certification_type)
        this.$router.push({
          //核心语句
          path: "/home/businessUserInfo", //跳转的路径
          query: {
            //路由传参时push和query搭配使用 ，作用时传递参数
            id: uid,
            certification_type: certification_type,
            grade: this.index
          }
        });
      }
    },
    showUserPoster(uid) {
      this.$router.push({
        path: `/home/businessCard?uid=${uid}`
      });
    },
    toMemberList(uid) {
      this.$router.push({
        path: `/home/groupMemberList?uid=${uid}`
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.title
  text-align center
  font-size 16px
  color #666
  border-bottom 1px solid #ccc
  padding-bottom 10px
  span
    color red
    font-size 20px
.tab-list
  height 40px
  line-height 40px
  display flex
  text-align center
  border-bottom 1px solid #ccc
  font-size 14px
  .item
    width 100px
    position relative
    cursor pointer
    &:first-child::after
      content ''
      display inline-block
      position absolute
      width 1px
      height 20px
      top 10px
      right 0
      background #ccc
  .on
    color #e93323
    border-bottom 2px solid #e93323
.people-box
  padding 10px
  .people
    display flex
    cursor pointer
    margin-bottom 10px
    padding 5px 10px
    &:hover
      background-color wheat
    .img
      width 70px
      height 70px
      border-radius 50%
      border 1px solid #ccc
      overflow hidden
      img
        width 100%
        height 100%
    .name
      margin-left 15px
      .tip
        color #666
        font-size 12px
        margin-top 10px
        .brokerage{
          color :red
        }
      .time
        color #999
        font-size 12px
        margin-top 15px
    .user-poster
      color white
      background-color red
      border-radius 14px
      font-size 12px
      height 18px
      padding 2px 4px
      margin-top 30px
    .sale
      margin-left 100px
      display flex
      margin-top 20px
      div
        width 60px
        text-align center
        >span
          color #e93323
</style>
